import { AsyncPageRender } from '@components/AsyncComponent';
import { pageModule } from '@components/pageModule';

export const ROUTES = {
    NewView: AsyncPageRender(() => pageModule(import('./NewView'))),
    View: AsyncPageRender(() => pageModule(import('./View'))),
    Review: AsyncPageRender(() => pageModule(import('./Review'))),
    Uploads: AsyncPageRender(() => pageModule(import('./Uploads'))),
    TipDesigner: AsyncPageRender(() => pageModule(import('./TipDesigner'))),
};
